var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tree"},_vm._l((_vm.items),function(item){return _c('TreeItem',{key:item.id,attrs:{"item":item},on:{"update":_vm.update}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }